var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppModal',{attrs:{"settings":_vm.modalSettings}},[_c('MileageModalContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }